const listeners = new Set();
let unlocked = false;

export const getAudioUnlocked = () => unlocked;

export const markAudioUnlocked = () => {
  if (unlocked) return;
  unlocked = true;
  listeners.forEach((listener) => listener(true));
};

export const subscribeAudioUnlocked = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
